<template>
  <div>
    <div class="d-flex justify-content-between align-items-center">
      <h4 class="mb-0 ml-2" style="font-size: 16px">Upcoming Appointments</h4>
    </div>
    <div v-if="scheduleEvents.length > 0" class="border-top p-2 mt-2">
      <div
        class="d-flex"
        v-for="(event, index) in scheduleEvents"
        :key="index"
      >
        <div style="width: 95%; font-size: 14px;">
          <i style="font-size: 8px" class="fa fa-circle p-2 text-primary"></i>
          <b style="font-size: 13px;">{{
            formatEventDate(event.startDateTime)
          }}</b>
          - {{ event.services }} {{ event.provider ? `with` : `` }}
          <i>{{ event.provider }}</i> at
          {{ event.locationName }}
          {{ event.recurrency ? recurrenceDetails(event.recurrency) : `` }}
        </div>
        <div>
          <div class="ml-auto">
            <i
                v-if="!event.chargedEncounter || canEditChargedEvents"
                @click="$emit('edit', { id: event.id, type: event.type })"
                class="fas fa-edit text-success hover-pointer"
                style="font-size: 14px"
            ></i>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="border-top p-2 mt-2 d-flex justify-content-center">
      <div class="text-center">
        <i style="color: #a2a2a3;">No upcoming appointments</i>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { formatDate } from "../../helpers/date";
import scheduleEventServer from "../../server/scheduleEvent";
import { mapGetters } from "vuex";
export default {
  name: "EocViewSummaryNextAppointments",
  props: ["episodeOfCareId", "showing"],
  data() {
    return {
      scheduleEvents: []
    };
  },
  mounted() {
    this.fetchNextAppointments();
  },
  computed: {
    ...mapGetters("layout", ["canEditChargedEvents"])
  },
  methods: {
    formatEventDate(date) {
      return formatDate(date);
    },
    async fetchNextAppointments() {
      this.scheduleEvents = await scheduleEventServer.getNextAppointmentsForSummary(
        this.episodeOfCareId
      );
    },
    monthRecurrenceTextGenerator(recurrence) {
      const date = moment(recurrence.startDateTime, "yyyy-MM-DD");
      const day = date.date();
      const weekDayName = date.format("dddd");
      const prefixes = ["first", "second", "third", "fourth", "fifth"];
      const weekLabel = prefixes[Math.floor(day / 7)];

      switch (recurrence.monthlyRepeat) {
        case "ByDayOfMonth":
          return `Monthly, on day ${day}`;
        case "ByDayOfWeek":
          return `Monthly, on the ${weekLabel} ${weekDayName}`;
        default:
          break;
      }
    },
    recurrenceDetails(data) {
      const recurrence = data;
      const repeat = recurrence?.frequencyNumber;
      const unit = recurrence?.frequencyUnit.toLowerCase();
      const endType = recurrence?.endType;
      const selectedDays = [];
      let endText = "";

      for (const day in recurrence) {
        if (recurrence[day] === true) {
          selectedDays.push(day.charAt(0).toUpperCase() + day.substring(1));
        }
      }

      if (endType === "ByOccurrences") {
        endText = `, ends after ${recurrence.occurrences} ocurrences`;
      } else if (endType === "ByDate") {
        endText = `, until ${this.formatDateOnly(recurrence.endDate)}`;
      }

      let daysText = "";
      if (selectedDays.length > 0) {
        daysText = `on ${selectedDays.join(", ")}`;
      }

      return `${unit !== "months" ? `(Repeats every ` : ``} ${
        unit !== "months" ? repeat : ``
      } ${
        unit !== "months"
          ? repeat > 1
            ? unit
            : unit.substring(0, unit.length - 1)
          : ``
      } ${daysText}${
        unit === "months"
          ? `, ${this.monthRecurrenceTextGenerator(recurrence)}`
          : ``
      }${endText})`;
    }
  },
  watch: {
    showing(newValue) {
      if (newValue) {
        this.fetchNextAppointments();
      }
    }
  }
};
</script>

<style></style>
